import React, { useState } from "react";

import { styled } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import AwsUpload from "./../../utils/AwsUpload";
import { Grid, Typography, Box } from "@mui/material";
import { useAxios } from "../../hooks/";
import pages from "../../constants/pages";
import {
  OuterBox,
  SubheaderSection,
  LoadingButton,
  ButtonContainer,
} from "./../../components";
import { useSelector } from "react-redux";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";

const Preview = styled("video")(({ theme }) => ({
  width: "100%",
  borderRadius: "16px",
  objectFit: "cover",
  [theme.breakpoints.up("sm")]: {
    height: "70vh",
  },
  [theme.breakpoints.down("sm")]: {
    height: "60vh",
  },
}));

export default function VideoPreview({ userData }) {
  const axios = useAxios({ baseURL: "mox_api_2" });

  const axiosDigipass = useAxios({
    baseURL: "digipass",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const { visitor_id, popUp, docFace, clickPhotoURL } = location.state || {};
  const { visitorData } = useSelector((state) => state.memberDetails);
  const queryParams = new URLSearchParams(location.search);

  const bookingId = queryParams.get("booking_id");
  const visitorId = queryParams.get("visitor_id");
  const popup = queryParams.get("popup");
  const doc_face = queryParams.get("doc_face");
  const entityId = queryParams.get("entity_id");
  const userTypeId = queryParams.get("user_type_id");
  const autoConsent = queryParams.get("auto_consent");
  const fromPreview = queryParams.get("from_preview");
  const indepentent = queryParams.get("indepentent");

  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [livelinessError, setLivelinessError] = useState([]);

  function captureAgain() {
    // Wait a short moment to ensure stream is stopped before navigating
    setTimeout(() => {
      navigate(clickPhotoURL + "&from_preview=true", {
        state: {
          blob: "",
          blob2: "",
          matchPercentage: "",
          popup,
          clickPhotoURL,
          docFace,
        },
      });
    }, 300);
  }

  const checkingLiveliness = async () => {
    setLoading(true);
    // const fileurl = await AwsUpload(userData.state.blob, "video");
    // const fileurl =
    //   "https://dc-chat-media.s3.ap-south-1.amazonaws.com/sample_data_files/1692246547202.webm";

    //  video_url: fileurl,
    //     visitor_id: sessionStorage.getItem("visitorId"),
    const userDocData = JSON.parse(
      localStorage.getItem(`userPayload_${visitorId}`)
    );
    axiosDigipass({
      url: `event/verify/booking`,
      method: "POST",
      disableRedirect: true,
      data: {
        name: " ",
        face_data: getVisitorFaceData(visitorId),
        is_encrypted_face: true,
        aadhar_data: userDocData,

        phone_number: visitorData.phoneNumber,
        ...(visitorId && {
          visitor_id: visitorId,
        }),
      },
    })
      .then((response) => {
        if (response.status) {
          let key = visitorId;

          localStorage.setItem(key, response.data.encrypted_face_data);

          if (!!popUp) {
            navigate(
              `${pages.Verification?.route}?visitor_id=${visitorId}&doc_face=true&booking_id=-1&entity_id=-1&user_type_id=0&popup=${popUp}`
            );
          } else if (bookingId == -1 && docFace == "true") {
            navigate(
              `${pages.Verification?.route}?visitor_id=${visitorId}&doc_face=true&booking_id=-1&entity_id=-1&user_type_id=${userTypeId}&doc_verify=true`
            );
          } else if (bookingId == -1) {
            setCountdown(5);
            const interval = setInterval(() => {
              setCountdown((prev) => {
                if (prev === 1) {
                  clearInterval(interval);
                }
                return prev - 1;
              });
            }, 1000);
            setSuccess(true);
          } else if (docFace == "true") {
            navigate(
              `${pages.Verification.route}?visitor_id=${
                visitorId || ""
              }&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&doc_face=${doc_face}&auto_consent=${autoConsent}${
                indepentent ? "&indepentent=" + indepentent : ""
              }`
            );
          } else {
            let key = visitorId;
            localStorage.setItem(key, response.data.encrypted_face_data);

            let url = "admin/profile/get-visitor-booking-status";

            let method = "POST";

            let data = {
              visitor_id: visitorId,
              entity_id: entityId,
              user_type_id: userTypeId,
              booking_id: bookingId,
              face_data: getVisitorFaceData(visitorId),
            };

            axios({
              url: url,
              disableRedirect: true,
              method: method,
              data: data,
            }).then((response) => {
              if (response.status) {
                let state = {
                  state: {
                    userData: response.data,
                    // match_percentage: matchPercentage,
                    // face_data: fileurl,
                  },
                };

                if (userTypeId == 1) {
                  navigate(
                    `${pages.EventSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                } else if (
                  userTypeId == 3 ||
                  userTypeId == 4 ||
                  userTypeId == 6
                ) {
                  navigate(
                    `${pages.CampusSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                } else if (userTypeId == 2) {
                  navigate(
                    `${
                      indepentent
                        ? pages.IndependentAppointmentSummary.route
                        : pages.AppointmentSummary.route
                    }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                } else if (userTypeId == 5) {
                  navigate(
                    `${pages.HotelSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
                    state
                  );
                }
              }
            });
          }
        } else {
          setLivelinessError(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        console.error("Error in Aws upload:", error);
      });
  };

  function proceedToNext(fileurl) {
    setLoading(true);
    const userPayloadString = localStorage.getItem("userPayload");
    const userPayload = JSON.parse(userPayloadString);
    axios({
      url: "/booking/appointment/verification",
      method: "PATCH",
      data: {
        livliness_check_status: 1,
        livliness_video_url: fileurl,
        ...userPayload,
        visitor_id: sessionStorage.getItem("visitorId"),
        id: sessionStorage.getItem("id"),
      },
    })
      .then((response) => {
        if (response.status) {
          console.log(response.data);

          const destination = `${
            pages.Success.route
          }?ref-id=${sessionStorage.getItem("ref_id")}&booking-type=${
            userPayload.booking_type
          }`;
          navigate(destination);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error update verification detils:", error);
      });

    ///////////////////////
    // axiosDigipass({
    //   url: `event/verify/booking`,
    //   method: "POST",
    //   disableRedirect: true,
    //   data: {
    //     name: " ",
    //     face_data: fileurl2.replace(/^data:image\/[a-z]+;base64,/, ""),

    //     aadhar_data: userDocData,

    //     phone_number: appointmentData.phone_number || visitorData.phoneNumber,
    //     ...(visitorId && {
    //       visitor_id: visitorId,
    //     }),
    //   },
    // })
    //   .then((response) => {
    //     if (response.status) {
    //       // if (userTypeId == 5) {
    //       //   let key = visitorId;

    //       //   localStorage.setItem(key, response.data.encrypted_face_data);

    //       //   axiosDigipass({
    //       //     url: `hotel/booking/guest/verify`,
    //       //     method: "POST",
    //       //     disableRedirect: true,
    //       //     data: {
    //       //       booking_ref_id: bookingId,
    //       //       // booking_id: bookingId,
    //       //       hotel_id: hotelID,
    //       //       visitor_data: {
    //       //         visitor_id: visitor_id,
    //       //         booking_type: "event",
    //       //         ...userDocData,
    //       //       },
    //       //     },
    //       //   }).then((response) => {
    //       //     if (response.status) {
    //       //       navigate(pages.HotelSummary.path + hotelID + "/" + bookingId);
    //       //     }
    //       //   });
    //       // }
    //       let key = visitorId;

    //       localStorage.setItem(key, response.data.encrypted_face_data);

    //       if (!!popUp) {
    //         navigate(
    //           `${pages.Verification?.route}?visitor_id=${visitorId}&doc_face=true&booking_id=-1&entity_id=-1&user_type_id=0&popup=${popUp}`
    //         );
    //       } else if (bookingId == -1 && docFace == "true") {
    //         navigate(
    //           `${pages.Verification?.route}?visitor_id=${visitorId}&doc_face=true&booking_id=-1&entity_id=-1&user_type_id=${userTypeId}&doc_verify=true`
    //         );
    //       } else if (bookingId == -1) {
    //         setCountdown(5);
    //         const interval = setInterval(() => {
    //           setCountdown((prev) => {
    //             if (prev === 1) {
    //               clearInterval(interval);
    //             }
    //             return prev - 1;
    //           });
    //         }, 1000);
    //         setSuccess(true);
    //       } else if (docFace == "true") {
    //         navigate(
    //           `${pages.Verification.route}?visitor_id=${
    //             visitorId || ""
    //           }&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&doc_face=${doc_face}&auto_consent=${autoConsent}${
    //             indepentent ? "&indepentent=" + indepentent : ""
    //           }`
    //         );
    //       } else {
    //         let key = visitorId;
    //         localStorage.setItem(key, response.data.encrypted_face_data);

    //         let url = "admin/profile/get-visitor-booking-status";

    //         let method = "POST";

    //         let data = {
    //           visitor_id: visitorId,
    //           entity_id: entityId,
    //           user_type_id: userTypeId,
    //           booking_id: bookingId,
    //           face_data: getVisitorFaceData(visitorId),
    //         };

    //         axios({
    //           url: url,
    //           disableRedirect: true,
    //           method: method,
    //           data: data,
    //         }).then((response) => {
    //           if (response.status) {
    //             let state = {
    //               state: {
    //                 userData: response.data,
    //                 match_percentage: matchPercentage,
    //                 face_data: fileurl,
    //               },
    //             };

    //             if (userTypeId == 1) {
    //               navigate(
    //                 `${pages.EventSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
    //                 state
    //               );
    //             } else if (
    //               userTypeId == 3 ||
    //               userTypeId == 4 ||
    //               userTypeId == 6
    //             ) {
    //               navigate(
    //                 `${pages.CampusSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
    //                 state
    //               );
    //             } else if (userTypeId == 2) {
    //               navigate(
    //                 `${
    //                   indepentent
    //                     ? pages.IndependentAppointmentSummary.route
    //                     : pages.AppointmentSummary.route
    //                 }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
    //                 state
    //               );
    //             } else if (userTypeId == 5) {
    //               navigate(
    //                 `${pages.HotelSummary.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeId}&auto_consent=${autoConsent}`,
    //                 state
    //               );
    //             }
    //           }
    //         });
    //       }
    //     } else {
    //       setLivelinessError(response.data);
    //     }
    //     setLoading(false);
    //   })
    //   .catch((error) => {
    //     setLoading(false);

    //     console.error("Error in Aws upload:", error);
    //   });
  }

  var blob = URL.createObjectURL(userData.state.blob);
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        // justifyContent: "space-between",
        alignItems: "center",
        px: 2,
        py: 3,
        bgcolor: "#ffffffff",
      }}
    >
      {/* Header */}
      <Typography
        variant="h6"
        fontWeight={600}
        sx={{
          mb: 2,
          textAlign: "center",
          fontSize: { xs: "1.1rem", sm: "1.3rem" },
        }}
      >
        Preview Your Recording
      </Typography>

      {/* Video Preview Box */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "480px", // looks like mobile UI even on desktop
          bgcolor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Preview controls src={blob} playsinline muted loop autoplay />

        {livelinessError.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="h6" sx={{ color: "red", mb: 1 }}>
              Verification Failed
            </Typography>
            {livelinessError.map((step, index) => (
              <Typography
                key={index}
                variant="body2"
                sx={{ color: "#555", textAlign: "center" }}
              >
                {step === "face found"
                  ? "Face detected but unable to verify liveness. Kindly try again."
                  : step}
              </Typography>
            ))}
          </Box>
        )}

        {loading && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ mt: 1, textAlign: "center" }}
          >
            It may take a few seconds...
          </Typography>
        )}

        {/* Buttons */}
        <Box
          sx={{
            mt: 3,
            width: "100%",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1.5,
          }}
        >
          {!livelinessError.length > 0 && (
            <LoadingButton
              loading={loading}
              fullWidth
              sx={{
                py: 1.2,
                borderRadius: "12px",
                fontSize: "1rem",
              }}
              onClick={checkingLiveliness}
            >
              Proceed Next
            </LoadingButton>
          )}
          <LoadingButton
            onClick={captureAgain}
            backgroundColor="gray"
            disabled={loading}
            fullWidth
            sx={{
              py: 1.2,
              borderRadius: "12px",
              fontSize: "1rem",
              bgcolor: "#ccc !important",
              color: "#000 !important",
            }}
          >
            Capture Again
          </LoadingButton>
        </Box>
      </Box>

      {/* Optional Footer (countdown / success) */}
      {success && (
        <Typography
          variant="body2"
          sx={{ mt: 2, color: "green", textAlign: "center" }}
        >
          Redirecting in {countdown}...
        </Typography>
      )}
    </Box>
  );
}
